module.exports = __webpack_public_path__ + "static/img/left-flash.8e5cd0e3.png";